<template>
  <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
    <v-col :cols='[this.$vuetify.breakpoint.smAndDown ? 12 : 6]' class='text-center'>
      <v-btn large @click='roll' v-if='!bingo'>Roll</v-btn>
      <v-btn large @click='cum' v-if='bingo && !came'>Cum</v-btn>
      <h1>{{currentSelectedCell.id}}</h1>
      <h4>{{currentSelectedCell.desc}}</h4>
      <v-img v-if='!this.$vuetify.breakpoint.smAndDown' :src='currentSelectedCell.img' height='50vh' contain lazy-src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="></v-img>
    </v-col>
    <v-col :cols='[this.$vuetify.breakpoint.smAndDown ? 12 : 6]'>
      <table>
        <tr>
          <th></th>
          <th>B</th>
          <th>I</th>
          <th>T</th>
          <th>C</th>
          <th>H</th>
        </tr>
        <tr>
          <th>1</th>
          <v-hover v-for="index in 5" v-slot:default='{ hover }'>
            <td>
              <v-img :src="shuffledCells[index - 1].img" width="7rem" height="7rem" lazy-src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" :class="[!selected.includes(shuffledCells[index - 1].id) ? notSelectedClass : '']">
                <v-expand-transition>
                  <div
                  v-if="!hover && selected.includes(shuffledCells[index - 1].id)"
                  class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal white--text"
                  style="height: 100%;"
                  >
                    {{shuffledCells[index - 1].shortDesc}}
                  </div>
                </v-expand-transition>
              </v-img>
            </td>
          </v-hover>
        </tr>
        <tr>
          <th>2</th>
          <v-hover v-for="index in 5" v-slot:default='{ hover }'>
            <td>
              <v-img :src="shuffledCells[index + 4].img" width="7rem" height="7rem" lazy-src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" :class="[!selected.includes(shuffledCells[index + 4].id) ? notSelectedClass : '']">
                <v-expand-transition>
                  <div
                  v-if="!hover && selected.includes(shuffledCells[index + 4].id)"
                  class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal white--text"
                  style="height: 100%;"
                  >
                    {{shuffledCells[index + 4].shortDesc}}
                  </div>
                </v-expand-transition>
              </v-img>
            </td>
          </v-hover>
        </tr>
        <tr>
          <th>3</th>
          <v-hover v-for="index in 5" v-slot:default='{ hover }'>
            <td>
              <v-img :src="shuffledCells[index + 9].img" width="7rem" height="7rem" lazy-src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" :class="[!selected.includes(shuffledCells[index + 9].id) ? notSelectedClass : '']">
                <v-expand-transition>
                  <div
                  v-if="!hover && selected.includes(shuffledCells[index + 9].id)"
                  class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal white--text"
                  style="height: 100%;"
                  >
                    {{shuffledCells[index + 9].shortDesc}}
                  </div>
                </v-expand-transition>
              </v-img>
            </td>
          </v-hover>
        </tr>
        <tr>
          <th>4</th>
          <v-hover v-for="index in 5" v-slot:default='{ hover }'>
            <td>
              <v-img :src="shuffledCells[index + 14].img" width="7rem" height="7rem" lazy-src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" :class="[!selected.includes(shuffledCells[index + 14].id) ? notSelectedClass : '']">
                <v-expand-transition>
                  <div
                  v-if="!hover && selected.includes(shuffledCells[index + 14].id)"
                  class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal white--text"
                  style="height: 100%;"
                  >
                    {{shuffledCells[index + 14].shortDesc}}
                  </div>
                </v-expand-transition>
              </v-img>
            </td>
          </v-hover>
        </tr>
        <tr>
          <th>5</th>
          <v-hover v-for="index in 5" v-slot:default='{ hover }'>
            <td>
              <v-img :src="shuffledCells[index + 19].img" width="7rem" height="7rem" lazy-src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" :class="[!selected.includes(shuffledCells[index + 19].id) ? notSelectedClass : '']">
                <v-expand-transition>
                  <div
                  v-if="!hover && selected.includes(shuffledCells[index + 19].id)"
                  class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal white--text"
                  style="height: 100%;"
                  >
                    {{shuffledCells[index + 19].shortDesc}}
                  </div>
                </v-expand-transition>
              </v-img>
            </td>
          </v-hover>
        </tr>
      </table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'sissyBingo',
    data: () => ({
      notSelectedClass: 'notSelectedCSS',
      selected: [],
      selectedCell: '',
      available: ['B1', 'I1', 'T1', 'C1', 'H1', 'B2', 'I2', 'T2', 'C2', 'H2', 'B3', 'I3', 'T3', 'C3', 'H3', 'B4', 'I4', 'T4', 'C4', 'H4', 'B5', 'I5', 'T5', 'C5', 'H5'],
      currentSelectedCell: {},
      bCount: 0,
      iCount: 0,
      tCount: 0,
      cCount: 0,
      hCount: 0,
      oneCount: 0,
      twoCount: 0,
      threeCount: 0,
      fourCount: 0,
      fiveCount: 0,
      bingo: false,
      came: false,
      cells: [
        {
          img: 'https://i.imgur.com/4kUpxm2.jpg',
          desc: 'Blow the tip of a dildo for 2 minutes.',
          shortDesc: 'Blow tip'
        },
        {
          img: 'https://i.imgur.com/2iu4bo1.jpg',
          desc: 'Watch porn for five minutes. Rub yourself, but NO STROKING!',
          shortDesc: 'Rub yourself'
        },
        {
          img: 'https://i.imgur.com/GDy1Tqq.jpg',
          desc: 'Make out with the tip of a dildo for 2 minutes.',
          shortDesc: 'Kiss tip'
        },
        {
          img: 'https://i.imgur.com/vwBziXM.jpg',
          desc: 'Wear a gag when not doing anything with your mouth for the remainder of the game(This includes while cumming).',
          shortDesc: 'Wear a gag'
        },
        {
          img: 'https://i.imgur.com/dMbmUEB.jpg',
          desc: 'Fuck yourself on your back for 5 minutes.',
          shortDesc: 'Back fuck'
        },
        {
          img: 'https://i.imgur.com/ZgJSZ0f.jpg',
          desc: 'Blow and jerk as many dildos as you can at once for 3 minutes.',
          shortDesc: 'Gang jerk'
        },
        {
          img: 'https://i.imgur.com/p2IOxob.jpg',
          desc: 'Wear panties for the remainder of the game(This includes while cumming).',
          shortDesc: 'Wear panties'
        },
        {
          img: 'https://i.imgur.com/ZwBqvJi.jpg',
          desc: 'Blow a dildo while you ride another for 5 minutes.',
          shortDesc: 'Double team'
        },
        {
          img: 'https://i.imgur.com/MnVMGwN.jpg',
          desc: 'Deepthroat a dildo for 2 minutes. Try to hold it at least once for 15 seconds.',
          shortDesc: 'Deepthroat'
        },
        {
          img: 'https://i.imgur.com/l2zWFyw.jpg',
          desc: 'Wear a skirt for the remainder of the game(This includes while cumming).',
          shortDesc: 'Wear a skirt'
        },
        {
          img: 'https://i.imgur.com/IPSKPs9.jpg',
          desc: 'Lick a dildo, base to tip, 15 times slowly.',
          shortDesc: 'Lick dildo'
        },
        {
          img: 'https://i.imgur.com/Nl7mdb5.jpg',
          desc: 'Ride a dildo for 5 minutes.',
          shortDesc: 'Ride dildo'
        },
        {
          img: 'https://i.imgur.com/VG6dCoz.jpg',
          desc: 'Wear a bra for the remainder of the game(This includes while cumming).',
          shortDesc: 'Wear a bra'
        },
        {
          img: 'https://i.imgur.com/bpBg6bi.jpg',
          desc: 'Shave your clitty.',
          shortDesc: 'Shave clitty'
        },
        {
          img: 'https://i.imgur.com/oNwUb22.jpg',
          desc: 'Wear a butt plug when not fucking anything for the remainder of the game(This includes while cumming).',
          shortDesc: 'Butt plug'
        },
        {
          img: 'https://i.imgur.com/ZOPMtII.jpg',
          desc: 'Wear nipple clamps/clothespins for the remainder of the game(This includes while cumming).',
          shortDesc: 'Nipple clamps'
        },
        {
          img: 'https://i.imgur.com/Y0F7lCM.jpg',
          desc: 'Fuck yourself doggystyle for 5 minutes.',
          shortDesc: 'Doggystyle'
        },
        {
          img: 'https://i.imgur.com/Ye4zwB4.jpg',
          desc: 'Wear stockings for the remainder of the game(This includes while cumming).',
          shortDesc: 'Stockings'
        },
        {
          img: 'https://i.imgur.com/5bM6jtS.jpg',
          desc: 'Wear chastity until you get a bingo.',
          shortDesc: 'Chastity'
        },
        {
          img: 'https://i.imgur.com/CttUkwQ.jpg',
          desc: 'Lick the base/balls of a dildo for 2 minutes.',
          shortDesc: 'Lick balls'
        },
        {
          img: 'https://i.imgur.com/elOaT3A.jpg',
          desc: 'Fuck yourself on your side for 5 minutes.',
          shortDesc: 'Side fuck'
        },
        {
          img: 'https://i.imgur.com/nQEYGgo.jpg',
          desc: 'Wear makeup for the remainder of the game(This includes while cumming).',
          shortDesc: 'Makeup'
        },
        {
          img: 'https://i.imgur.com/hgep4UM.jpg',
          desc: 'Free play. Fuck yourself however you would like for 8 minutes.',
          shortDesc: 'Free fuck'
        },
        {
          img: 'https://i.imgur.com/1RCr45e.jpg',
          desc: 'Finger your ass for 10 minutes.',
          shortDesc: 'Finger ass'
        },
        {
          img: 'https://i.imgur.com/g5r2cJ4.jpg',
          desc: 'Wear a collar for the remainder of the game(This includes while cumming).',
          shortDesc: 'Collar'
        },
      ],
      shuffledCells: [],
      cumMethods: [
        {
          id: 'Free Throw',
          img: 'https://i.imgur.com/QSVtaWh.gif',
          desc: 'Cum however you like!'
        },
        {
          id: 'Panty Shot',
          img: 'https://i.imgur.com/CH3Nktg.gif',
          desc: 'Cum in your panties!'
        },
        {
          id: 'Creampie',
          img: 'https://i.imgur.com/YGvGCQa.gif',
          desc: 'Cum on your hand, spread it on your asshole.'
        },
        {
          id: 'Facial',
          img: 'https://i.imgur.com/qmxKCJd.gif',
          desc: 'Cum on your face.'
        },
        {
          id: 'Hand Job',
          img: 'https://i.imgur.com/Xar7si8.gif',
          desc: 'Cum in your hand. Lick it up!'
        },
        {
          id: 'Clean Floors',
          img: 'https://i.imgur.com/EnZaDkA.gif',
          desc: 'Cum on the floor. Lick it up!'
        },
      ]
    }),
    methods: {
      roll(){
        this.selectedCell = this.available[Math.floor(Math.random() * this.available.length)];
        this.currentSelectedCell = this.shuffledCells.find(cell => cell.id == this.selectedCell);
        this.selected.push(this.selectedCell)
        this.available.splice(this.available.indexOf(this.selectedCell), 1);
        switch(this.selectedCell[0]) {
          case "B": this.bCount++
          break;
          case "I": this.iCount++
          break;
          case "T": this.tCount++
          break;
          case "C": this.cCount++
          break;
          case "H": this.hCount++
          break;
        }
        switch(this.selectedCell[1]) {
          case "1": this.oneCount++
          break;
          case "2": this.twoCount++
          break;
          case "3": this.threeCount++
          break;
          case "4": this.fourCount++
          break;
          case "5": this.fiveCount++
          break;
        }
        if(this.bCount == 5 || this.iCount == 5 || this.tCount == 5 || this.cCount == 5 || this.hCount == 5 || this.oneCount == 5 || this.twoCount == 5 || this.threeCount == 5 || this.fourCount == 5 || this.fiveCount == 5){
          this.bingo = true;
        }
        if((this.selected.includes('B1') && this.selected.includes('I2') && this.selected.includes('T3') && this.selected.includes('C4') && this.selected.includes('H5')) || (this.selected.includes('B5') && this.selected.includes('I4') && this.selected.includes('T3') && this.selected.includes('C2') && this.selected.includes('H1'))){
          this.bingo = true
        }
      },
      shuffle(array){
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
      
          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
      
          // And swap it with the current element.
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
      
        return array;
      },
      cum(){
        this.currentSelectedCell = this.cumMethods[Math.floor(Math.random() * this.cumMethods.length)];
        this.came = true;
      }
    },
    beforeMount() {
      this.shuffledCells = this.shuffle(this.cells);
      for(let i = 0; i < this.available.length; i++){
        this.shuffledCells[i].id = this.available[i];
      }
      this.shuffledCells.length = (this.available.length);
    }
}
</script>

<style scoped>
  td{
    height: 6rem;
    width: 6rem;
  }

  .notSelectedCSS {
    -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);
  }

  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
</style>